<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{$t('common.dateRange')}}</span>
      <el-date-picker
        size="small"
        v-model="DataValue"
        type="daterange"
        :clearable="false"
        value-format="yyyy-MM-dd"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{$t('common.btn.search')}}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{$t('common.btn.cancel')}}</el-button>
    </div>
    <div class="zMsgBtn">
      <el-button type="text" @click="down">{{$t('common.btn.download')}}</el-button>
    </div>
    <div class="zMsgTable">
      <i-table
        :list="list"
        :height="height"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
    </div>
  </div>
</template>

<script>
import iTable from "../../../../../../src/components/Table.vue";
import { domainName } from "../../../../../utility/index";
import moment from "moment";
import ITable from "./config/tableDemo.vue";
export default {
  components: {
    iTable,
    ITable,
  },
  data() {
    return {
      DataValue: [],
      height: "350",
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      bindCarId: "",
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD");
      const startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.DataValue = [startTime, endTime];
    },
    getDriverSwipingCard() {
      let startTime = "";
      let endTime = "";
      if (this.DataValue) {
        if (this.DataValue.length > 0) {
          startTime = this.DataValue[0];
          endTime = this.DataValue[1];
        }
      }
      console.log(this.bindCarId);
      let param = {
        companyId: sessionStorage.getItem("companyId"),
        carId: this.bindCarId,
        startTime: startTime,
        endTime: endTime,
      };

      this.$store
        .dispatch("checkManagement/GET_SELECTSPOTCHECKSTATEMENT", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.list = res.data.data.date;
              const tableColumn = res.data.data.label.map((item) => {
                let obj = {
                  align: "center",
                  prop: item.prop,
                  label: item.label,
                  width: item.prop === "id" ? "60" : "160",
                  render: (h, params) => {
                    console.log(h, params);
                    return h(ITable, {
                      props: {
                        time: params.row[item.prop],
                      },
                    });
                  },
                };
                return obj;
              });
              this.columns = tableColumn;
            }
          }
        })
        .catch((err) => {});
    },
    onSearch() {
      this.getDriverSwipingCard();
    },
    onClear() {
      this.getDate();
      this.getDriverSwipingCard();
    },
    handleSelectionChange(val) {
      this.selected = val;
    },

    down() {
      if (domainName) {
        if (domainName.split(":")[0] !== "localhost") {
          let startTime = "";
          let endTime = "";
          if (this.DataValue) {
            if (this.DataValue.length > 0) {
              startTime = this.DataValue[0];
              endTime = this.DataValue[1];
            }
          }
          let companyId = sessionStorage.getItem("companyId");
          let url = `https://${domainName}/v1/getExportExcel/exportSpotCheckStatement?companyId=${companyId}&carId=${this.bindCarId}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        } else {
          let host = "localhost:8080";
          let url = `https://${host}/v1/getExportExcel/exportSpotCheckStatement?companyId=${companyId}&carId=${this.bindCarId}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
